const debounceHeight = debounce(() => {
  equalheight(
    '.latest-news__inner.has-large .latest-news__card:nth-of-type(2), .latest-news__inner.has-large .latest-news__card:nth-of-type(3)',
  );
}, 25);

window.addEventListener('load', () => {
  if (windowWidth() > breakpointMd) {
    debounceHeight();
  }
});

window.addEventListener('resize', () => {
  if (windowWidth() > breakpointMd) {
    debounceHeight();
  }
});
